// Local translations
export const T = {
  en_GB: {
    flowLabel: "Flow",
    templateSettings: "Template Settings",
    templateSettingsDescription: "Configure the basic settings for this PDF template",
    name: "Name",
    namePlaceholder: "Template name",
    description: "Description",
    descriptionPlaceholder: "Optional description",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    includeProductDocuments: "Include product documents",
    includeProductDocumentsDescription:
      "Append attached product documents (e.g. KIID) for every product in the flow to the end of the generated PDF",
    save: "Save",
    saveChanges: "Saved",
    failedToSave: "Failed to save changes",
  },
  nb_NO: {
    flowLabel: "Flyt",
    templateSettings: "Malinnstillinger",
    templateSettingsDescription: "Konfigurer grunnleggende innstillinger for denne PDF-malen",
    name: "Navn",
    namePlaceholder: "Malnavn",
    description: "Beskrivelse",
    descriptionPlaceholder: "Valgfri beskrivelse",
    status: "Status",
    active: "Aktiv",
    inactive: "Inaktiv",
    includeProductDocuments: "Inkluder produktdokumenter",
    includeProductDocumentsDescription:
      "Legg ved tilknyttede produktdokumenter (f.eks. KIID) for alle produkter i flyten på slutten av den genererte PDF-en",
    save: "Lagre",
    saveChanges: "Lagret",
    failedToSave: "Kunne ikke lagre endringer",
  },
} as const;
